export default "__VITE_ASSET__07be3662__"